import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {searchBusinessPlaceFailure, searchBusinessPlaceSuccess} from "../../actions/BrandBusinessActions/searchBusinessPlaceActions";

function* searchBusinessPlace({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.searchBusinessPlace + "?placeName=" + encodeURIComponent(payload),
            isAuth: true,
        });
        console.log('====================================');
        console.log("SESRCH_BUSINESS_PLACES_SUCCESS status :", response.data.status);
        console.log("SESRCH_BUSINESS_PLACES_SUCCESS data :", response.data.response);
        console.log("SESRCH_BUSINESS_PLACES_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            searchBusinessPlaceSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("SESRCH_BUSINESS_PLACES_FAILURE status :", error?.response?.status);
        console.log("SESRCH_BUSINESS_PLACES_FAILURE data:", error?.response?.data);
        console.log("SESRCH_BUSINESS_PLACES_FAILURE error :", error);
        console.log('====================================');
        yield put(searchBusinessPlaceFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* searchBusinessPlaceSaga() {
    yield takeLatest(actionTypes.SESRCH_BUSINESS_PLACES_REQUEST, searchBusinessPlace);
}

export default searchBusinessPlaceSaga;
